import { Account } from "@/types/api"
import http from "./client"
import { store, persistor } from "@/lib/store"
import { clearAuth } from "@/lib/store/auth"
import { clearOrganizations } from "@/lib/store/organization"
import { ROUTES } from "@/routes/path"

export const login = async (email: string, password: string): Promise<Account> => {
  const res = await http.post(`/auth/login`, { email, password })
  return res.data
}

export const register = async (email: string, password: string, fullName: string): Promise<string> => {
  const res = await http.post(`/auth/register`, { email, password, name: fullName })
  return res.data
}

export const confirmRegistration = async (email: string, token: string): Promise<Account> => {
  const res = await http.post(`/auth/confirm-account`, { email, token })
  return res.data
}

export const resendConfirmation = async (email: string): Promise<any> => {
  const res = await http.post(`/auth/resend-registration-otp`, { email })
  return res.data
}

export const googleAuth = async (): Promise<{ url: string }> => {
  const res = await http.get(`/auth/google`)
  return res.data
}

export const googleCallback = async (code: string): Promise<Account> => {
  const res = await http.get(`/auth/google/callback?code=${code}`)
  return res.data
}

export const githubAuth = async (): Promise<{ url: string }> => {
  const res = await http.get(`/auth/github`)
  return res.data
}

export const githubCallback = async (code: string): Promise<Account> => {
  const res = await http.get(`/auth/github/callback?code=${code}`)
  return res.data
}

export const forgotPassword = async (email: string): Promise<{ message: string }> => {
  const res = await http.post(`/auth/forgot-password`, { email })
  return res.data
}

export const resetPasswordConfirm = async (email: string, token: string): Promise<{ message: string }> => {
  const res = await http.post(`/auth/reset-password-confirm`, { email, token })
  return res.data
}

export const resetPasswordChange = async (
  email: string,
  token: string,
  newPassword: string
): Promise<{ message: string }> => {
  const res = await http.post(`/auth/reset-password-change`, { email, token, new_password: newPassword })
  return res.data
}

export const logout = async () => {
  store.dispatch(clearAuth())
  store.dispatch(clearOrganizations())

  await persistor.purge()
  await persistor.flush()

  localStorage.removeItem("persist:organization")
  localStorage.removeItem("persist:auth")

  document.cookie.split(";").forEach((c) => {
    const eqPos = c.indexOf("=")
    const name = eqPos > -1 ? c.substr(0, eqPos) : c
    document.cookie = `${name.trim()}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
  })

  window.location.href = ROUTES.AUTH.LOGIN
}
